import {
  Button,
  Container,
  createStyles,
  rem,
  SimpleGrid,
  Text,
  Title,
} from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as ErrorImage } from '../../assets/Rejection.svg';
import MainLayout from '../../layout/mainLayout';

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: rem(80),
    paddingBottom: rem(80),
  },

  title: {
    fontWeight: 900,
    fontSize: rem(34),
    marginBottom: theme.spacing.md,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,

    [theme.fn.smallerThan('sm')]: {
      fontSize: rem(32),
    },
  },

  control: {
    [theme.fn.smallerThan('sm')]: {
      width: '100%',
    },
  },

  mobileImage: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  desktopImage: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },
}));

export default function ErrorPage() {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <MainLayout>
      <Container className={classes.root}>
        <SimpleGrid
          spacing={80}
          cols={2}
          breakpoints={[{ maxWidth: 'sm', cols: 1, spacing: 40 }]}
        >
          <ErrorImage className={classes.mobileImage} />
          <div>
            <Title className={classes.title}>Something is not right...</Title>
            <Text color="dimmed" size="lg">
              Page you are trying to open does not exist. You may have mistyped
              the address, or the page has been moved to another URL. If you
              think this is an error contact support.
            </Text>
            <Button
              variant="outline"
              size="md"
              mt="xl"
              color="#ebf6fc"
              className={classes.control}
              onClick={() => navigate('/')}
            >
              Get back to home page
            </Button>
          </div>
          <ErrorImage className={classes.desktopImage} />
        </SimpleGrid>
      </Container>
    </MainLayout>
  );
}
